export const _Cart_Add = (product) => {
  return {
    type: "ADD_PRODUCT",
    product: product,
  };
};

export const _Cart_Remove = (product) => {
  return {
    type: "REMOVE_PRODUCT",
    product: product,
  };
};

export const _Cart_Update = (cart) => {
  return {
    type: "UPDATE_CART",
    cart: cart,
  };
};

export const _Cart_Clean = () => {
  return {
    type: "CLEAN_CART",
  };
};

export const _Cart_Decrease = (product_id) => {
  return {
    type: "DECREASE_PRODUCT",
    product_id,
  };
};

export const _Set_Cart = (carts) => {
  return {
    type: "SET_CARTS",
    payload: carts,
  }
}

export const _Delivery = (
  product_id,
  address_id,
  delivery_date,
  delivery_shift,
  service_center_id,
  type,
  delivery_shift_name,
  service_center_name,
  address
) => {
  return {
    type: "DELIVERY_OPTIONS",
    id: product_id,
    address_id,
    delivery_date,
    delivery_shift,
    service_center_id,
    item_type: type,
    delivery_shift_name,
    service_center_name,
    address,
  };
};
